import { cn, StatusBadge } from "@nexxt/ui";
import { m } from "../../paraglide/messages.js";
import { useSceneTimeline } from "../motion/use-scene-timeline";
import { AppWindow } from "./app-window";

// Frontrow on the buyer's phone (ADR-286): the invitation from Guestlist, the time, the booking, then the order
// confirmed, shipped and invoiced.
const durations = [2200, 2400, 2200, 3200] as const;
const slots = [
  { time: "10:00", full: false },
  { time: "10:30", full: false },
  { time: "11:00", full: true },
  { time: "11:30", full: false },
];

export function FrontrowScene({ active, still, dark }: { active: boolean; still: boolean; dark: boolean }) {
  const step = useSceneTimeline(durations, active, still);
  return (
    <AppWindow app="frontrow" dark={dark} title="frontrow.nexxt" className={cn("is-phone", `is-step-${step}`)}>
      <div className="phone-screens">
        <div className={cn("phone-screen", step === 0 && "is-current")}>
          <p className="phone-from" data-app="guestlist">
            {m.scene_frontrow_invite_from()}
          </p>
          <p className="scene-heading">{m.scene_frontrow_invite()}</p>
          <p className="text-muted-foreground text-xs">Milan · 9–13 February · Arvo, Selva, Lumen</p>
          <span className="mock-button is-pressing">{m.scene_frontrow_book()}</span>
        </div>
        <div className={cn("phone-screen", step === 1 && "is-current")}>
          <p className="scene-heading">{m.scene_frontrow_pick()}</p>
          <p className="text-muted-foreground text-xs">Tue 10 February</p>
          <div className="slots">
            {slots.map((slot) => (
              <span
                key={slot.time}
                className={cn("slot", slot.full && "is-full", slot.time === "10:30" && "is-picked")}
              >
                {slot.full ? `${slot.time} · ${m.scene_frontrow_full()}` : slot.time}
              </span>
            ))}
          </div>
        </div>
        <div className={cn("phone-screen", step === 2 && "is-current")}>
          <StatusBadge tone="success" label={m.scene_frontrow_booked_badge()} />
          <p className="scene-heading">{m.scene_frontrow_booked()}</p>
          <p className="text-muted-foreground text-xs">Arvo · Selva</p>
        </div>
        <div className={cn("phone-screen", step === 3 && "is-current")}>
          <p className="scene-heading">
            {m.scene_frontrow_order()} <span className="font-mono">SO-2291</span>
          </p>
          <ol className="order-steps">
            <li>{m.scene_frontrow_step_confirmed()}</li>
            <li>{m.scene_frontrow_step_shipped()}</li>
            <li>{m.scene_frontrow_step_invoiced()}</li>
          </ol>
        </div>
      </div>
    </AppWindow>
  );
}
